import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useSetRecoilState, useRecoilValue } from 'recoil';

import { END_CUSTOMER } from 'connectors/userTypes';
import { GET_ACCOUNT } from 'connectors/queries/account';
import { notifyCommerceIncomplete } from 'connectors/bugsnag';
import { currentAccountState, authenticationState, baseAccountState } from 'state/atoms';
import { getAccountsUrlWithReturn } from 'utils/helpers/url';

const redirectToAccountSearch = () => window.location.replace(getAccountsUrlWithReturn());

// Run validations and load the account data into the state
export const useAccountLoad = ({ skip }) => {
  const { accountId, endCustomerAccountId, userType, isAuthenticated } =
    useRecoilValue(authenticationState);
  const [validation, setValidation] = useState({
    commerceComplete: true,
  });
  const setBaseAccount = useSetRecoilState(baseAccountState);
  const setAccount = useSetRecoilState(currentAccountState);

  const isEndCustomer = userType === END_CUSTOMER;
  const skipEndAccountQuery = isEndCustomer || !isAuthenticated || !endCustomerAccountId;

  const baseAccountRequest = useQuery(GET_ACCOUNT, {
    variables: { accountId },
    skip: skip || !isAuthenticated,
    onCompleted: (data) => {
      const account = data ? data.getAccount : {};

      const validationResults = {
        ...validation,
        commerceComplete: account.commerceComplete,
      };

      if (!validationResults.commerceComplete) {
        notifyCommerceIncomplete();
      }

      setValidation(validationResults);

      if (isEndCustomer) {
        setAccount(account);
      } else {
        setBaseAccount(account);
      }
    },
    onError: () => setValidation({ ...validation, commerceComplete: false }),
  });

  const endAccountRequest = useQuery(GET_ACCOUNT, {
    variables: { accountId: endCustomerAccountId },
    skip: skip || skipEndAccountQuery,
    onCompleted: (data) => {
      setAccount(data.getAccount || {});
    },
    onError: redirectToAccountSearch,
  });

  return [validation, { baseAccountRequest, endAccountRequest }];
};
